// 统计资源数量
export const statResourceCount = (resourceKind, resourceSubType, regionId, resources) => {
  let resourceCount = 0
  if (resourceKind === 150) { // 区域
    resources.forEach(item => {
      if ((resourceSubType === 255 || item.regionKind === resourceSubType) &&
        regionId === item.parentRegionId) {
        ++resourceCount
      }
    })
  }

  return resourceCount
}

// 统计正常资源数量
export const statNormalResourceCount = (resourceKind, resourceSubType, regionId, resources) => {
  let resourceCount = 0
  if (resourceKind === 150) { // 区域
    resources.forEach(item => {
      if ((resourceSubType === 255 || item.regionKind === resourceSubType) &&
        regionId === item.parentRegionId &&
        (item.encoderAlarmCount === 0 && item.streamNodeAlarmCount === 0 && item.dataNodeAlarmCount === 0 &&
          item.locationNodeAlarmCount === 0 && item.voiceNodeAlarmCount === 0) &&
        (item.encoderOfflineCount === 0 && item.streamNodeOfflineCount === 0 && item.dataNodeOfflineCount === 0 &&
          item.locationNodeOfflineCount === 0 && item.voiceNodeOfflineCount === 0)) {
        ++resourceCount
      }
    })
  }

  return resourceCount
}

// 统计离线资源数量
export const statOfflineResourceCount = (resourceKind, resourceSubType, regionId, resources) => {
  let resourceCount = 0
  if (resourceKind === 150) { // 区域
    resources.forEach(item => {
      if ((resourceSubType === 255 || item.regionKind === resourceSubType) &&
        regionId === item.parentRegionId &&
        (item.encoderCount > 0 && item.encoderCount === item.encoderOfflineCount)) {
        ++resourceCount
      }
    })
  }

  return resourceCount
}

// 统计告警资源数量
export const statAlarmResourceCount = (resourceKind, resourceSubType, regionId, resources) => {
  let resourceCount = 0
  if (resourceKind === 150) { // 区域
    resources.forEach(item => {
      if ((resourceSubType === 255 || item.regionKind === resourceSubType) &&
        regionId === item.parentRegionId &&
        (item.encoderAlarmCount > 0 || item.streamNodeAlarmCount > 0 || item.dataNodeAlarmCount > 0 ||
          item.locationNodeAlarmCount > 0 || item.voiceNodeAlarmCount > 0)) {
        ++resourceCount
      }
    })
  }

  return resourceCount
}



// WEBPACK FOOTER //
// ./src/views/common/mapNavigator/mapAction.js